export default function(instance) {
  return {
    getAllUsers(data) {
      Object.keys(data).forEach(
        k => !data[k] && data[k] !== undefined && delete data[k]
      );

      return instance.get("/api/users/admin/", { params: data });
    },
    getUsers() {
      return instance.get("/api/users/");
    },
    getUser(idUser) {
      return instance.get(`/api/users/admin/${idUser}/`);
    },
    updateUser(idUser, data) {
      return instance.put(`/api/users/admin/${idUser}/`, data);
    },
    updateFCMTokenUser(token) {
      return instance.post("/api/users/update/token/", {
        notification_token: token,
        platform: "web"
      });
    },
    confirmUser(idUser, data) {
      return instance.post(`/api/users/confirm/${idUser}/`, {
        addresses: [data.address]
      });
    },
    rejectUser(idUser) {
      return instance.get(`/api/users/reject/${idUser}/`);
    },
    deleteUser(idUser) {
      return instance.delete(`/api/users/admin/${idUser}/`);
    },

    //Family
    addFamilyMember(data) {
      return instance.post("/api/family_members/admin/", data);
    },
    updateFamilyMember(idMember, data) {
      return instance.put(`/api/family_members/admin/${idMember}/`, data);
    },
    deleteFamilyMember(idMember) {
      return instance.delete(`/api/family_members/admin/${idMember}`);
    }
  };
}
